import type { FaireProductEntity } from "../../entity_types/product";

export const p_tpvvg4agbp: FaireProductEntity = {
  token: "p_tpvvg4agbp",
  type: "product",
  name: "Ivory Wildflower Mini Bouquet #141",
  brandToken: "b_3ga4euf8eq",
  brandName: "Andaluca",
  imageUrl:
    "https://cdn.faire.com/fastly/c97a8c4d3b7e92098318c34e86efed671405e0329c9b0b0cd45e1af6b47d138b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34099ebd252639e4ca1802dab36f11dd5878b398930fa2f8877a20efa08cb569.jpeg",
    "https://cdn.faire.com/fastly/7126eb69410510df5c114c9844033df814d24e3456965a7886556aab5452bf47.jpeg",
    "https://cdn.faire.com/fastly/7a5c60ab9bcb9b6ee6d700bf3984a54106cc01dd481076600601f37198db8b1e.jpeg",
    "https://cdn.faire.com/fastly/e15bafaf8e6b1371c3fa2ec75d6366c5676e5953a47d9817d677b50224edc447.jpeg",
  ],
  priceDollars: 8.22,
  description:
    'Our floral team designed this beautiful MINI bouquet using an assortment of bunny tails, sola flower, and flax to create this charming and petit mini bouquet arrangement.  Each bouquet is designed and handcrafted in our California design studio and is a perfect decorative accent to your tablescape or vignette.\n\n- 8" long\n- Comes in packs of 6.\n- Each bouquet is placed in a decorative paper card.\n',
  tags: [],
  msrpDollars: 16.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:50.608Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
